export const piqStylesMobile: string = `
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

bcfds-modal-shell {
  --space-3: 0px;
}

#cashier [slot='modal-content-no-padding'] {
  padding: 0 !important;
}

.input {
  border: 1px solid #D6D9E0 !important;
}

.input::placeholder {
  color: var(--components-input-fg-primary, #0A0A0A) !important;
}

.input-wrapper {
  border-radius: 48px;
}

.input-wrapper input {
  padding-left: 18px !important;
}

.input-label-float {
  padding-left: 8px !important;
}

.input-wrapper .input-label-float {
  top: 50% !important;
}

.input-wrapper .input-label-float.active {
  margin-top: 8px !important; 
}

.input-wrapper .input-label-float.active+input {
  padding-top: 16px !important;
  padding-left: 14px !important;
}

.btn {
  height: 48px !important;
  padding-top: unset !important;
  padding-bottom: unset !important;
  font-size: 18px !important;
}

.show-pending-transactions { 
  padding: 12px 0 !important;
}

.show-pending-transactions .header-container {
  gap: 8px !important;
}

.show-pending-transactions .header-container h2 {
  display: flex !important;
  align-items: center !important;
  flex-grow: 0 !important;
  max-width: 100% !important;
  height: 24px !important;
}

div.time-option.false {
  background: var(--components-tag-bg, #D6D6D6) !important;
}

.time-option.active {
  background: var(--components-tag-bg-active, #0A0A0A) !important;
  color: #fff !important;
} 

.dropdown-label {
  position: sticky !important;
  color: var(--components-input-fg-secondary, #575757) !important;
  font-family: var(--font-family-body, Poppins) !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: var(--font-line-height-body-14, 11px);
  letter-spacing: var(--font-letter-spacing-body-14, -0.28px);
}

.dropdown-icon {
  position: sticky !important;
}

.header-container {
  display: flex !important;
  flex-wrap: wrap !important;
}

.header-container h2 {
  flex-basis: 100% !important;
}

.show-pending-transactions .header-container span.cancel-all-pending {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: min-content !important;
  height: 32px !important;
  padding: 0px 24px !important;
  background: var(--components-button-secondary-bg, rgba(255, 255, 255, 0.00)) !important;
  color: #F62828 !important;
  font-family: 'Poppins', sans-serif !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: var(--font-line-height-title-14, 17px) !important;
  letter-spacing: var(--font-letter-spacing-title-14, -0.28px) !important;
  text-align: center !important;
  border: 2px solid var(--components-button-secondary-border, #F62828) !important;
  border-radius: 40px !important;
}

.all-transactions > div:nth-child(4) {
  overflow: hidden;
  top: 0px;
  color: var(--text-primary, #0A0A0A);
  font-family: var(--font-family-title, Poppins);
  font-size: var(--font-size-title-16, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--font-line-height-title-16, 19px);
  letter-spacing: var(--font-letter-spacing-title-16, -0.32px);
  text-overflow: ellipsis;
}

p.tx-type {
  position: relative;
  top: 16% !important;
  left: 13px !important;
  padding-right: 24px !important; 
  background: transparent !important;
}

p.tx-type::before {
  position: absolute;
  top: 60px !important;
  padding: 4px 6px;
  background: var(--components-badges-badge-tag-bg-info-invert, #D6DAFF);
  font-family: Poppins, sans-serif;
  font-size: var(--font-size-title-10, 10px);
  font-style: normal;
  font-weight: 700;
  line-height: var(--font-line-height-title-10, 12px);
  letter-spacing: var(--font-letter-spacing-title-10, -0.2px);
  text-align: center;
  border-radius: 8px;
  content: '';
}

svg.iconify.iconify--ion.ion {
  width: 18px !important;
  height: 18px !important;
  background-color: #F0F0F0;
  border-radius: 9px;
  box-shadow: 0 0 0 15px #F0F0F0;
}

p.tx-type[title="status.completed"]::before {
  background: var(--components-badges-badge-tag-bg-success-invert, #DBEFDC);
  color: var(--components-badges-badge-tag-fg-success-invert, #4CAF50);
}

p.tx-type[title="status.failed"]::before {
  background: var(--components-badges-badge-tag-bg-error-invert, #FEEBEB);
  color: var(--components-badges-badge-tag-fg-error-invert, #F62828);
}

h2.amount.withdrawal {
  position: absolute;
  top: 20%;
  margin: 5px -46px !important;
  color: var(--text-primary, #0A0A0A) !important;
  font-family: var(--font-family-title, Poppins);
  font-size: var(--font-size-title-14, 14px) !important;
  font-style: normal;
  font-weight: 700;
  line-height: var(--font-line-height-title-14, 17px) !important;
  letter-spacing: var(--font-letter-spacing-title-14, -0.28px) !important;
  text-align: right;
}

#cashier .transactions-container .dropdown-container {
  padding: 0px !important;
}

h2.cashier-section-header {
  margin: 7px 0 7px 0 !important;
  font-family: var(--font-family-title, Poppins);
  font-size: var(--font-size-title-14, 14px) !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: var(--font-line-height-title-14, 17px) !important;
  letter-spacing: var(--font-letter-spacing-title-14, -0.28px);
}

.align-center.transactions {
  padding: 0 !important;
}

.align-center {
  max-width: 100% !important;
}

p.p {
  text-transform: capitalize;
}

p.p::after {
  white-space: pre;
  content: " - ";
}

.all-transactions .flex.space-between {
  position: relative;
  justify-content: flex-start !important;
  padding-left: 39px !important;
}

.all-transactions .flex.space-between p {
  color: var(--NEUTRAL-70, #575757);
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
  line-height: var(--font-line-height-heading-12, 18px);
  letter-spacing: -0.24px;
}

div.action-link svg {
  display: none;
}

#cashier .all-transactions {
  margin: 32px 0 12px 0 !important;
  padding: 0 24px !important;
  background: #fff !important;
  border-radius: 16px !important;
}

.action-link {
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  height: 32px;
  margin-top: 8px;
  margin-left: -24px !important;
  padding: 0 16px;
  background: #fff;
  color: #F62828 !important;
  font-family: Poppins, sans-serif !important;
  font-size: var(--font-size-title-14, 14px) !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: var(--font-line-height-title-14, 17px);
  letter-spacing: var(--font-letter-spacing-title-14, -0.28px) !important;
  border: 2px solid var(--components-button-secondary-border, #F62828) !important;
  border-radius: 16px;
}

.header-container span:first-of-type {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex: 1 0 0 !important;
  gap: 10px !important;
  height: 32px !important;
  padding: 0 16px !important;
  background: var(--buttons-color) !important;
  color: #fff !important;
  font-family: 'Poppins', sans-serif !important;
  font-size: var(--font-size-title-14, 14px) !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: var(--font-line-height-title-14, 17px) !important;
  letter-spacing: var(--font-letter-spacing-title-14, -0.28px) !important;
  text-align: center !important;
  border-radius: 40px !important;
}

.header-container span:nth-of-type(2) {
  background: var(--components-button-secondary-bg, rgba(255, 255, 255, 0.00)) !important;
  border: 2px solid var(--components-button-secondary-border, #F62828) !important;
  border-radius: 16px !important;
}

#cashier {
  width: 100%;
}

.set-amount .predefinedvalues {
  margin: -8px -8px 0 0;
}

.set-amount .predefinedvalues > * {
  padding: 8px 8px 0 0 !important;
}

.set-amount .predefinedvalues button {
  height: 32px !important;
  padding: 0 10px !important;
  background-color: #D6D6D6 !important;
  color: #0A0A0A !important;
}

.set-amount .predefinedvalues button.active {
  background-color: #0A0A0A !important;
  color: #FFFFFF !important;
}

.payment-method-collection {
  display: flex;
  align-items: center;
  border-radius: 24px;
} 

.payment-method {
  min-height: 96px;
  background: var(--background-secondary, #F0F0F0);
  border-radius: 24px;
  transition: background .2s ease !important;
}

.payment-method-header {
  min-height: 96px;
}

.payment-method-details {
  margin: 12px;
  padding: 12px !important;
  background: var(--background-primary, #FFF) !important;
  border-radius: 24px;
}

.list-payment-methods__list {
  display: grid;
  gap: 8px;
}

.logo-container {
  overflow: hidden;
  display: flex;
  justify-content: center !important;
  align-items: center;
  order: -1;
  width: 64px !important;
  height: 64px !important;
  background: var(--background-primary, #FFF);
  border-radius: 50%;
}

.logo-container .logo-icon {
  max-width: calc(100% - 16px) !important;
  max-height: calc(100% - 16px) !important;
  margin: auto;
}

.payment-method .payment-method-header .label-container {
  margin-left: 20px !important;
  padding: 0 !important;
}

.payment-method .payment-method-header:before {
  position: absolute !important;
  right: 24px;
  width: 20px !important;
  height: 20px !important;
  border: 2px solid #000 !important;
  border-radius: 25px !important;
  content: '';
}

.payment-method-header {
  padding: 0 24px !important;
  border-radius: 10px;
}

.payment-method-label {
  margin: 0 !important;
}

.payment-method.active .payment-method-header:after {
  position: absolute;
  top: calc(50% - 4px) !important;
  right: 30px;
  width: 8px !important;
  height: 8px !important;
  margin: 0 !important;
  transform: none !important;
  content: '';
}

.dropdown-toggler {
  height: 48px !important;
  padding: 10px 18px !important;
  line-height: 13px !important;
  border: 1px solid #D6D6D6 !important;
  border-radius: 48px !important;
}

.dropdown-content {
  background-color: #fff !important;
  border-radius: 24px !important;
  box-shadow: 0 2px 8px 0 rgba(10, 10, 10, 0.10) !important;
}

.dropdown.open .dropdown-container .dropdown-toggler {
  z-index: 1001;
  position: relative;
  transform: translateY(8px);
  width: calc(100% - 16px);
  margin: 0 8px;
}

#cashier .all-transactions .action-link:hover {
  background: #fff !important;
}

.dropdown.open .dropdown-container .dropdown-content {
  top: 0;
  padding: 60px 10px 0;
}

.btn.time-option.card {
  height: 24px !important;
  padding: 0 12px !important;
  font-family: var(--font-family-body, Poppins);
  font-size: 12px !important;
  line-height: var(--font-line-height-heading-12, 21px);
  letter-spacing: var(--font-letter-spacing-body-12, -0.24px);
}

.btn.time-option.card.false {
  color: var(--components-tag-text, #0A0A0A);
}

.btn.time-option.card.active {
  color: var(--components-tag-text-active, #FFF);
  font-family: var(--font-family-body, Poppins);
  font-size: var(--font-size-body-12, 12px) !important;
  font-style: normal;
  font-weight: 400;
  line-height: var(--font-line-height-body-14, 21px);
  letter-spacing: var(--font-letter-spacing-body-14, -0.28px);
}

.pending-transaction-row span:nth-child(2) {
  width: fit-content !important;
}

.dropdown.open .dropdown-container .dropdown-content::-webkit-scrollbar {
  background-color: rgba(0,0,0,0);
}

.dropdown.open .dropdown-container::before {
  position: absolute;
  z-index: 1001;
  top: 0;
  left: 0;
  display: inline-block;
  width: calc(100% - 16px);
  height: 60px;
  background: #fff;
  border-radius: 32px 32px 0 0;
  content: ' ';
}

.dropdown .dropdown-container .dropdown-content {
  transition: unset !important;
  -webkit-transition: unset !important;
}

.notice-container {
  align-items: center !important;
}

.notice-container .ion-icon-left,
.notice-container .ion-icon-right {
  position: static;
  display: flex;
}

.notice-container .ion-icon-left {
  order: 1;
}

.notice-container div {
  order: 2;
}

.notice-container .ion-icon-right {
  order: 3;
}

.notice-container .ion-icon-left .notice-alert {
  padding: 0;
}

.footer-left back-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  padding: 0 var(--space-4);
  background: var(--components-button-quaternary-bg, #D6D6D6);
  font-family: 'Poppins';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  border-radius: 48px;
}
`;
